// Frontend game data utilities
export const RANKS = [
  { id: 1, name: 'Street Thug', expRequired: 0, salary: 100 },
  { id: 2, name: 'Gang Member', expRequired: 250, salary: 200 },
  { id: 3, name: 'Car Thief', expRequired: 600, salary: 350 },
  { id: 4, name: 'Getaway Driver', expRequired: 1100, salary: 500 },
  { id: 5, name: 'Professional Thief', expRequired: 1800, salary: 700 },
  { id: 6, name: 'Crew Leader', expRequired: 2700, salary: 1000 },
  { id: 7, name: 'Crime Boss', expRequired: 4000, salary: 1500 },
  { id: 8, name: 'Mafia Don', expRequired: 6000, salary: 2500 },
  { id: 9, name: 'Kingpin', expRequired: 9000, salary: 4000 },
  { id: 10, name: 'Legend', expRequired: 13500, salary: 10000 },
  { id: 11, name: 'Crime Lord', expRequired: 20000, salary: 15000 },
  { id: 12, name: 'Empire Builder', expRequired: 30000, salary: 25000 },
  { id: 13, name: 'Underground King', expRequired: 45000, salary: 40000 },
  { id: 14, name: 'Shadow Master', expRequired: 65000, salary: 60000 },
  { id: 15, name: 'Criminal Mastermind', expRequired: 90000, salary: 85000 },
  { id: 16, name: 'Vice President', expRequired: 120000, salary: 120000 },
  { id: 17, name: 'Executive Officer', expRequired: 160000, salary: 170000 },
  { id: 18, name: 'Board Member', expRequired: 210000, salary: 230000 },
  { id: 19, name: 'Senior Partner', expRequired: 270000, salary: 300000 },
  { id: 20, name: 'Managing Director', expRequired: 340000, salary: 400000 },
  { id: 21, name: 'Chief Executive', expRequired: 420000, salary: 550000 },
  { id: 22, name: 'Vice Chairman', expRequired: 510000, salary: 750000 },
  { id: 23, name: 'Chairman', expRequired: 610000, salary: 1000000 },
  { id: 24, name: 'Supreme Leader', expRequired: 720000, salary: 1500000 },
  { id: 25, name: 'Criminal Emperor', expRequired: 850000, salary: 2500000 }
];

export const getCurrentRank = (currentRank: number) => {
  return RANKS.find(rank => rank.id === currentRank);
};

export const getNextRank = (currentRank: number) => {
  return RANKS.find(rank => rank.id === currentRank + 1);
};

export const canRankUp = (currentExp: number, currentRank: number): boolean => {
  const nextRank = RANKS.find(rank => rank.id === currentRank + 1);
  return nextRank ? currentExp >= nextRank.expRequired : false;
};

export const getRankProgress = (currentExp: number, currentRank: number): { progress: number; currentRankExp: number; nextRankExp: number } => {
  const currentRankData = RANKS.find(rank => rank.id === currentRank);
  const nextRankData = RANKS.find(rank => rank.id === currentRank + 1);
  
  if (!currentRankData) {
    return { progress: 0, currentRankExp: 0, nextRankExp: 0 };
  }
  
  if (!nextRankData) {
    // Max rank reached
    return { progress: 100, currentRankExp: currentRankData.expRequired, nextRankExp: currentRankData.expRequired };
  }
  
  const currentRankExp = currentRankData.expRequired;
  const nextRankExp = nextRankData.expRequired;
  const expInCurrentRank = currentExp - currentRankExp;
  const expNeededForNextRank = nextRankExp - currentRankExp;
  
  const progress = Math.min(100, Math.max(0, (expInCurrentRank / expNeededForNextRank) * 100));
  
  return { progress, currentRankExp, nextRankExp };
};

export const formatTime = (seconds: number): string => {
  if (seconds <= 0) return '0s';
  
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;
  
  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  if (remainingSeconds > 0 || parts.length === 0) parts.push(`${remainingSeconds}s`);
  
  return parts.join(' ');
};
